module.exports = __webpack_public_path__ + "static/img/jt1.2f26a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/jt1.jpg
// module id = xISN
// module chunks = 1